<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="mb-1">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link :to="'/'">Home</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">Notification settings</li>
            </ol>
          </nav>
        </div>

        <h2 class="mb-3">Notification settings</h2>
        <p class="text-muted">
          Choose who may receive inventory alerts. They still need to add the app to their Home Screen
          and tap Enable alerts.
        </p>

        <div v-if="loading" class="text-muted mb-3">Loading…</div>

        <div class="table-responsive mb-4" v-else>
          <table class="table align-middle">
            <thead>
              <tr>
                <th>User</th>
                <th>Alerts</th>
                <th>Subscribed</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!recipients.length">
                <td colspan="3" class="text-muted">No users found.</td>
              </tr>
              <tr v-for="recipient in recipients" :key="recipient._id">
                <td>{{ recipient.name }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-sm"
                    :class="recipient.inventoryAlerts ? 'btn-success' : 'btn-outline-secondary'"
                    :disabled="savingId === recipient._id"
                    @click="toggleAlerts(recipient)"
                  >
                    {{ recipient.inventoryAlerts ? 'On' : 'Off' }}
                  </button>
                </td>
                <td>
                  <span v-if="recipient.subscribed">
                    Yes
                    <small class="text-muted">
                      ({{ recipient.subscriptionCount }} device{{ recipient.subscriptionCount === 1 ? '' : 's' }})
                    </small>
                  </span>
                  <span v-else-if="recipient.inventoryAlerts" class="text-warning">
                    Allowed, waiting for Enable alerts
                  </span>
                  <span v-else class="text-muted">No</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          :disabled="runningCheck"
          @click="runCheck"
        >
          {{ runningCheck ? 'Running check…' : 'Run inventory check now' }}
        </button>
        <div v-if="checkResult" class="small text-muted mt-2">{{ checkResult }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationSettings',
  data: () => ({
    recipients: [],
    loading: true,
    savingId: null,
    runningCheck: false,
    checkResult: '',
  }),
  async mounted() {
    const { data: me } = await this.$api.get('/me');
    if (me.superuser !== true) {
      this.$router.replace('/');
      return;
    }
    await this.loadRecipients();
  },
  methods: {
    async loadRecipients() {
      this.loading = true;
      try {
        const { data } = await this.$api.get('/push/recipients');
        this.recipients = data.data;
      } catch (error) {
        console.error('Error loading recipients:', error);
      } finally {
        this.loading = false;
      }
    },
    async toggleAlerts(recipient) {
      this.savingId = recipient._id;
      try {
        const { data } = await this.$api.patch(`/push/recipients/${recipient._id}`, {
          inventoryAlerts: !recipient.inventoryAlerts,
        });
        this.recipients = this.recipients.map((row) => (
          row._id === recipient._id ? { ...row, ...data } : row
        ));
      } catch (error) {
        console.error('Error updating recipient:', error);
      } finally {
        this.savingId = null;
      }
    },
    async runCheck() {
      this.runningCheck = true;
      this.checkResult = '';
      try {
        const { data } = await this.$api.post('/inventory/check', {}, { timeout: 30000 });
        if (!data.notified) {
          this.checkResult = 'No unordered shortages. Nothing sent.';
        } else {
          const push = data.push || {};
          this.checkResult = `Sent “${data.message}” to ${push.sent || 0} of ${push.attempted || 0} device(s).`;
        }
      } catch (error) {
        console.error('Error running inventory check:', error);
        this.checkResult = error.response?.data?.error?.message || 'Check failed.';
      } finally {
        this.runningCheck = false;
      }
    },
  },
}
</script>
